import { render, staticRenderFns } from "./LoginModal.vue?vue&type=template&id=51bcecb2&"
import script from "./LoginModal.vue?vue&type=script&lang=ts&"
export * from "./LoginModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports